import React, { useState, useContext, useEffect } from "react";
import { Link } from "react-router-dom";
import * as actionType from "../../../../store/actions";
import { ConfigContext } from "../../../../contexts/ConfigContext";

const NavDarkMode = () => {
  const [isOpen, setIsOpen] = useState(false);
  const configContext = useContext(ConfigContext);
  const { layoutType } = configContext.state;
  const { dispatch } = configContext;

  useEffect(() => {
    if (isOpen) {
      dispatch({ type: actionType.LAYOUT_TYPE, layoutType: "dark" });
    } else {
      dispatch({ type: actionType.LAYOUT_TYPE, layoutType: "menu-light" });
    }
  }, [isOpen, dispatch]);

  return (
    <React.Fragment>
      <Link
        to="#"
        className={layoutType === "dark" ? "active" : ""}
        onClick={() => setIsOpen((prev) => !prev)}
      >
        <i className="feather icon-sun" />
      </Link>
    </React.Fragment>
  );
};

export default NavDarkMode;
